import * as Material from "@mui/material";
import React from "react";

export function Form_Button(props) {
    const {item} = props;
    const { inputSize = "normal" } = item;
    const { clickHandler = () => {}, disabled = false, color = "primary" } = item;
    const height = inputSize === "normal" ? 56 : 43;


    const [isDisabled, setIsDisabled] = React.useState(typeof disabled === "boolean" ? disabled : true);


    React.useEffect(() => {
        if (typeof disabled === "function"){
            setIsDisabled(() => disabled());
        }
    }, [disabled]);

    return (<>
        <Material.Button
            color={color}
            variant='contained'
            fullWidth={true}
            style={{height: `${height}px`}}
            disabled={isDisabled}
            onClick={clickHandler}
        >{item.label}</Material.Button>
    </>);
}